var _path, _rect, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgL6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 29H1V30H2V29ZM18 15.8022C18 16.3544 18.4477 16.8022 19 16.8022C19.5523 16.8022 20 16.3544 20 15.8022H18ZM15.4511 30C16.0034 30 16.4511 29.5523 16.4511 29C16.4511 28.4477 16.0034 28 15.4511 28V30ZM7 2H14V0H7V2ZM3 29V6H1V29H3ZM18 6V15.8022H20V6H18ZM15.4511 28H2V30H15.4511V28ZM14 2C16.2091 2 18 3.79086 18 6H20C20 2.68629 17.3137 0 14 0V2ZM7 0C3.68629 0 1 2.68629 1 6H3C3 3.79086 4.79086 2 7 2V0Z",
    fill: "#00619E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 9,
    height: 6,
    rx: 1,
    stroke: "#00619E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 28C0.447715 28 0 28.4477 0 29C0 29.5523 0.447715 30 1 30V28ZM14 30C14.5523 30 15 29.5523 15 29C15 28.4477 14.5523 28 14 28V30ZM1 30H14V28H1V30Z",
    fill: "#00619E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 22.9614V23C13 24.1046 12.1046 25 11 25C9.89543 25 9 24.1046 9 23V22.9614C9 22.6578 9.06782 22.358 9.1985 22.0839L11 18.306L12.8015 22.0839C12.9322 22.358 13 22.6578 13 22.9614Z",
    stroke: "#00619E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7788 10.0335H21C21.5523 10.0335 22 10.4812 22 11.0335V12C22 13.1046 22.8954 14 24 14V14C25.1046 14 26 13.1046 26 12V9.06934C26 7.96477 26.8954 7.06934 28 7.06934H29.0994",
    stroke: "#00619E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24L24 26L28.6562 20.2155C29.4963 21.2479 30 22.5652 30 24C30 27.3137 27.3137 30 24 30C20.6863 30 18 27.3137 18 24C18 20.6863 20.6863 18 24 18C24.5179 18 25.0206 18.0656 25.5 18.189",
    stroke: "#00AED9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL6);
export default __webpack_public_path__ + "static/media/l6.79c5076f2e977d7a2bf5c200c9e3f2e6.svg";
export { ForwardRef as ReactComponent };